import React from 'react';
import AppIcon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  variant?: 'default' | 'recognition' | 'achievement' | 'progress' | 'goals' | 'surveys';
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'Heart',
  title,
  description,
  actionLabel,
  onAction,
  variant = 'default',
}) => {
  const getVariantColor = () => {
    switch (variant) {
      case 'recognition':
        return 'text-red-500';
      case 'achievement':
        return 'text-amber-500';
      case 'progress':
        return 'text-blue-500';
      case 'goals':
        return 'text-violet-500';
      case 'surveys':
        return 'text-emerald-500';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <AppIcon name={icon} size={32} className={getVariantColor()} />
      </div>
      <h3 className="text-lg font-medium text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-md leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <Button variant="outline" onClick={onAction}>
          <AppIcon name="Plus" size={16} className="me-2" />
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
